import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';
 import { login as loginApi } from '../services/api';
 import {signUp as signUpApi} from "../services/api";


// Create context
const AuthContext = createContext(null);

// Auth provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check for saved user on initial load
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  // Login function

const login = async (credentials) => {
  setLoading(true);
  setError(null);

  try {
    const response = await loginApi(credentials); // ✅ call API method
    setUser(response.user);
    localStorage.setItem('user', JSON.stringify(response.user));
    localStorage.setItem('token',response.token);
    return response.user;
  } catch (err) {
    setError(err.message || 'Failed to login');
    throw err;
  } finally {
    setLoading(false);
  }
};



const signup = async (userData) => {
  setLoading(true);
  setError(null);

  try {
    const response = await signUpApi(userData); // call API method
    setUser(response.user);
    localStorage.setItem('user', JSON.stringify(response.user));
    localStorage.setItem('token', response.token);
    return response.user;
  } catch (err) {
    setError(err.message || 'Signup failed');
    throw err;
  } finally {
    setLoading(false);
  }
};



  // Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // Context value
  const value = {
    user,
    loading,
    error,
    login,
    logout,
    signup,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for using auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};